module.exports = __webpack_public_path__ + "static/media/prep_table_small.b14afdbc.svg";